import styled from 'styled-components';

const SList = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #161d1f;

  > div {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 8px 0 16px 8px;

    > div {
      height: 24px;
      width: 24px;
      min-height: 24px;
      min-width: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #e2dffd;

      > img {
        height: 16px;
        width: 16px;
        object-fit: contain;
      }
    }

    > p {
      font-size: 14px;
      line-height: 20px;
      color: #1a055d;

      > span {
        font-weight: 700;
      }
    }
  }

  ul {
    padding-left: 8px;

    li {
      h3 {
        font-weight: 700;
        margin-bottom: 4px;
      }

      p {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        &::before {
          content: '';
          background-color: #161d1f;
          border-radius: 50%;
          display: block;
          height: 5px;
          max-height: 5px;
          max-width: 5px;
          min-height: 5px;
          min-width: 5px;
          width: 5px;
          margin: 7px 8px 0 0;
        }
      }

      &:has(ul) {
        margin-bottom: 12px;
      }
    }

    &:first-child {
      padding-left: 0;
    }
  }
`;

export { SList };
